import { NEWSLETTER_SUBSCRIPTION_EVENTS } from '../event_bus_modules/newsletter_subscription';
import { initializeForm } from '../utils/form';
import recaptcha, { getPublicKeyOfScope } from '../utils/recaptcha';

function initializeNewsletterForm($newsletterContainer) {
  let $emailInputValid = false;

  const $confirmNewsletterButton = $newsletterContainer.find(
    '.newsletter-confirm-button'
  );
  const $countriesButtons = $newsletterContainer.find(
    '.countries-toggle-list > button'
  );
  const $emailInput = $newsletterContainer.find('.email-wrapper input');
  const $newsletterSubscriptionForm = $newsletterContainer.find(
    '.newsletter-subscription-form'
  );
  const csrfToken = $newsletterSubscriptionForm
    .find('input[name="csrfmiddlewaretoken"]')
    .val();
  const $formInputs = $newsletterSubscriptionForm.find(
    'input[type=hidden].country'
  );
  const submitUrl = $newsletterSubscriptionForm.attr('action');
  const $subscriptionCompleteMessage = $newsletterContainer.find(
    '.newsletter-subscription-complete'
  );

  if ($emailInput.attr('type') === 'hidden' && $emailInput.val().length > 0) {
    $emailInputValid = true;
  }

  initializeForm($newsletterSubscriptionForm, {
    preventDefault: true,
  });

  const onCountryClicked = (event) => {
    const countryCode = $(event.target).data('value');
    const inputName = 'subscriber_' + countryCode;
    const $inputElement = $newsletterSubscriptionForm.find(
      'input[name=' + inputName + ']'
    );
    if ($inputElement.val() === '') $inputElement.val('true');
    else $inputElement.val('');
    updateConfirmNewsletterButton();
  };

  const onEmailInputChange = ({ target }) => {
    // simple check if any value has been put, to be replaced by final form library
    $emailInputValid = !!target.value.length;
    updateConfirmNewsletterButton();
  };

  const updateConfirmNewsletterButton = () => {
    let countriesSelected = $newsletterSubscriptionForm.find(
      'input[value=true].country'
    );
    const disabled = countriesSelected.length === 0 || !$emailInputValid;
    $confirmNewsletterButton.attr('disabled', disabled);
  };

  const resetModalState = () => {
    $emailInputValid = false;
    $emailInput.get(0).value = '';
    $countriesButtons.each((_, button) => button.classList.remove('active'));
    $confirmNewsletterButton.attr('disabled', true);
  };

  const confirmNewsletterSubscription = () => {
    recaptcha(getPublicKeyOfScope($newsletterSubscriptionForm)).then(
      (recaptchaResponseToken) => {
        let payload = {
          email: $emailInput.val(),
          'g-recaptcha-response': recaptchaResponseToken,
        };
        $formInputs.each((_, formInput) => {
          payload[$(formInput).attr('name')] = $(formInput).val() === 'true';
        });
        EVENT_BUS.dispatch(
          NEWSLETTER_SUBSCRIPTION_EVENTS.NEWSLETTER_SUBSCRIPTION_CONFIRMED,
          { submitUrl, payload, csrfToken }
        );
        $newsletterSubscriptionForm.hide();
        $subscriptionCompleteMessage.removeClass('d-none');

        $newsletterContainer.trigger('bidx1.subscribed-to-newsletter');
      }
    );
  };

  $emailInput.on('keyup', onEmailInputChange);
  $countriesButtons.on('click', onCountryClicked);
  $newsletterContainer.on('hide.bs.modal', resetModalState);
  $confirmNewsletterButton.on('click', confirmNewsletterSubscription);

  $(window).on('unload', () => {
    $emailInput.off('keyup', onEmailInputChange);
    $countriesButtons.off('click', onCountryClicked);
    $newsletterContainer.off('hide.bs.modal', resetModalState);
    $confirmNewsletterButton.off('click', confirmNewsletterSubscription);
  });
}

$(() => {
  const $newsletterModal = $('#newsletter-signup');
  const $newsletterSignUpPage = $('#newsletter-signup-page');
  const $newsletterEmailSent = $('#email-sent-container');
  const $modalCloseButton = $newsletterModal.find('.close-button');

  initializeNewsletterForm($newsletterSignUpPage);
  initializeNewsletterForm($newsletterEmailSent);

  function resetScreen() {
    $(window).scrollTop(0);
    setTimeout(() => {
      $modalCloseButton.click();
    }, 3000);
  }

  $newsletterModal.on('bidx1.subscribed-to-newsletter', resetScreen);

  $newsletterSignUpPage.on('bidx1.subscribed-to-newsletter', () => {
    setTimeout(() => {
      location.href = '/';
    }, 5000);
  });
});
